<template>
	<div id="app">
		<router-view />
		</transition>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				transitionName: 'slide-left'
			}
		},
		updated() {
			window.scroll(0, 0);
		},
		watch: {
			'$route'(to, from) {
				const toDepth = to.path.split('/').length
				const fromDepth = from.path.split('/').length
				// this.transitionName = toDepth > fromDepth ? 'slide-right' : 'slide-left'
			}
		}
	}
</script>
<style lang="scss"></style>
